<template>
  <div class="overview">
    <chart-item
      v-for="chart, index in reports"
      :key="chart.id"
      :data="chart"
      :toolTip="getToolTip(chart)"
      :colorOverride="getColor(index)"
      :percentColorOverride="'#63A6DA'"
    />
    <chart-item-link
      v-show="reports.length > 0"
      :canGoForward="isNextPage"
      :canGoBack="isPreviousPage"
      @onGoBack="onGoBack()"
      @onGoForward="onGoForward()"
    />
  </div>
</template>

<script>
import ChartItem from './ChartItem_v2'
import ChartItemLink from './ChartItemLink_v2'

export default {
  components: {
    ChartItem,
    ChartItemLink,
  },

  data() {
    return {
      reports: [],
      reportIndex: 0,
      colors: {
        page1: [
          '#63A6DA',
          '#DF5B96',
          '#244A96',
          '#F09639',
          '#244A96',
          '#F09639',
          '#63A6DA',
        ],
        page2: [
          '#63A6DA',
          '#DF5B96',
          '#244A96',
          '#F09639',
          '#F09639',
          '#003057',
          '#63A6DA',
        ],
      },
      toolTips: {
        satisfaction_with_surgeon: 'One week post-op, patients rate their satisfaction with the surgeon who \
          performed their eye surgery from 0-10. Your percentage score is the total of all scores, \
          divided by the number of responses. Note: This RayPRO report is not activated until there \
          is a minimum of 2 responses.',
        satisfaction_with_outcomes: 'Three months post-op and one year post-op, patients rate their overall \
          satisfaction with the outcome of their eye surgery from 0-10. Your percentage score is the total of \
          all scores at three months and one year, divided by the number of responses. Note: This RayPRO report \
          is not activated until there is a minimum of 2 responses.',
        satisfaction_with_hospital: 'One week post-op, patients rate their satisfaction with the hospital where \
          they had their eye surgery from 0-10. Your percentage score is the total of all scores, divided \
          by the number of responses. Note: This RayPRO report is not activated until there is a minimum \
          of 2 responses.',
        dysphotopsia: 'Three months and one year post-op, patients are asked if they experience any visual disturbances \
          during the day and in the evening/night-time. Patients rate from 0 (never) to 10 (frequent and bothersome). \
          Your score is the percentage of patients who gave a negative response (9 or 10) indicating frequent \
          disturbances. Note: This RayPRO report is not activated until there is a minimum of 2 responses.',
        spectacle_independence: 'Three months post-op, patients say how often they wear glasses from 0 (Always) \
          to 10 (Never) for activities at different distances, plus medical conditions. Your overall percentage \
          score is the total of all scores for all categories, divided by the number of responses. Note: This \
          RayPRO report is not activated until there is a minimum of 2 responses.',
        target_refraction: 'Three months post-op, patients are asked if they have the visual outcomes that \
          they discussed and agreed with their surgeon. Patients can choose between ‘Yes’, ‘No’ and \
          ‘Not sure’. Your score represents the percentage of patients who answered ‘Yes’. Note: \
          This RayPRO report is not activated until there is a minimum of 2 responses.',
        registered_patients: 'This report provides a cumulative view of how many patients have been registered on \
          RayPRO. If patients do not respond to the 1-week questionnaire then your Active Patients score will reduce.',
        registered_users: 'This report provides an administrative view of how many users have been registered on \
          RayPRO.',
        iol_usage: 'This report provides an overview of the number of IOLs implanted.',
        catprom: 'One month post-op, patients are asked to complete the Cat-PROM5 questionnaire (a widely-used \
          standard for measuring visual disability outcomes). Cat-PROM5 scores are measured on a scale of 0-100 where \
          100 is the best score.',
        catprom_preop: 'Prior to surgery, patients may be asked to complete the Cat-PROM5 questionnaire (a widely-used \
          standard for measuring visual disability outcomes). This provides a comparison to your post-operative \
          Cat-PROM5 score.',
        catquest: 'One month post-op, patients are asked to complete the Catquest-9SF questionnaire (a widely-used \
          standard for measuring visual disability outcomes). This number represents your Catquest-9SF score on a \
          scale of 0-100, where 100 is the best score. When you drill down into this report, your scores will be \
          graphed in their original Rasch-scaled form.',
        catquest_preop: 'Prior to surgery, patients may be asked to complete the Catquest-9SF questionnaire (a \
          widely-used standard for measuring visual disability outcomes). This number represents your pre-op \
          Catquest-9SF score on a scale of 0-100, where 100 is the best score. When you drill down into this report, \
          your scores will be graphed in their original Rasch-scaled form.',
      },
    }
  },

  props: {
    iols: {type: Array},
    pagedReports: {type: Array},
    globalReports: {type: Array},
    contextSurgeon: {type: Object},
  },

  computed: {
    isNextPage() {
      return this.pagedReports.indexOf(this.reports) + 1 < this.pagedReports.length
    },

    isPreviousPage() {
      return this.pagedReports.indexOf(this.reports) !== 0
    },
  },

  methods: {
    onGoBack() {
      this.reports = this.pagedReports[--this.reportIndex]
    },

    onGoForward() {
      this.reports = this.pagedReports[++this.reportIndex]
    },

    getToolTip(report) {
      let context = Array.isArray(report) ? report[0] : report
      if (Object.getOwnPropertyNames(this.toolTips).includes(context.slug)) {
        return this.toolTips[context.slug]
      }
      return ''
    },

    getColor(index) {
      if (this.reports === this.pagedReports[0]) {
        return this.colors.page1[index]
      }
      return this.colors.page2[index]
    },
  },

  watch: {
    pagedReports() {
      this.reportIndex = 0
      this.reports = this.pagedReports[0]
    },
  },
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'
@import '../../../stylesheets/helpers/mixins'

.overview
  display: flex
  flex-wrap: wrap

  .chart-title
    .active
      display: none !important
</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/Overview_v2.vue